import { useRouter } from "next/router";

/** Maps the current route to the page title shown in the header. */
export const getPageTitle = (pathname: string): string => {
  if (pathname === "/") return "Shipments";
  if (pathname.startsWith("/intelligence")) return "Intelligence";
  if (pathname.startsWith("/exceptions-v2")) return "Exceptions v2";
  if (pathname.startsWith("/exceptions")) return "Exceptions";
  if (pathname.startsWith("/cases")) return "Support Cases";
  if (pathname.startsWith("/services")) return "Services";
  if (pathname.startsWith("/settings/help")) return "Help";
  if (pathname.startsWith("/quotes")) return "Quotes";
  if (pathname.startsWith("/bulk-shipments")) return "Uploads";
  if (pathname.startsWith("/pickups")) return "Pickups";
  if (pathname.startsWith("/billing")) return "Billing";
  if (pathname.startsWith("/queries")) return "Queries";
  if (pathname.startsWith("/label-design")) return "Label design";
  if (pathname.startsWith("/returns")) return "Returns";
  if (pathname.startsWith("/settings")) return "Settings";
  if (pathname.startsWith("/help") || pathname.startsWith("/faq")) return "Help";
  return "";
};

export const NavigationPrimaryLinks = () => {
  const { pathname } = useRouter();
  const title = getPageTitle(pathname);

  return (
    <div className="items-center hidden h-full md:flex">
      <div className="text-base font-semibold leading-none">{title}</div>
    </div>
  );
};
